import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgUserFill} from "~/assets/svg/user-fill.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmUserFillIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgUserFill id={id} className={cx(simpleIconStyles(size), commonStyles.strokeColor(color), className)} />;
};
